import dayjs from 'dayjs';

const getDateWithTimezoneOffset = date => {
  if (!date || typeof date !== 'string') {
    return undefined;
  }
  // added extra 1 hour (60000 * 60)
  const userTimezoneOffset = new Date().getTimezoneOffset() * 60000 + 60000 * 60;
  return new Date(Date.parse(date.split('T')[0]) + userTimezoneOffset);
};

const getDiffDatesWithFormatted = ({ start, end, isFull = false }) => {
  const startDate = dayjs(start);
  const endDate = dayjs(end);
  const diff = startDate.diff(endDate);

  const days = dayjs.duration(diff).days();
  const hours = dayjs.duration(diff).hours();
  const minutes = dayjs.duration(diff).minutes();
  const seconds = dayjs.duration(diff).seconds();

  const daysString = days > 0 ? `${days}d ` : '';
  const hoursString = hours > 0 ? `${hours}h ` : '';
  const minutesString = minutes > 0 ? `${minutes}m ` : '';
  const secondsString = seconds > 0 ? `${seconds}s` : '';

  const daysFullString = days > 0 ? `${days} day(s) ` : '';
  const hoursFullString = hours > 0 ? `${hours} hour(s) ` : '';
  const minutesFullString = minutes > 0 ? `${minutes} minute(s) ` : '';
  const secondsFullString = seconds > 0 ? `${seconds} seconds` : '';

  if (isFull) return `${daysFullString}${hoursFullString}${minutesFullString}${secondsFullString}`;

  return `${daysString}${hoursString}${minutesString}${secondsString}`;
};

const getMonths = (locales = 'en', options = { month: 'long' }) =>
  Array.from({ length: 12 }, (e, i) =>
    new Date(null, i + 1, null).toLocaleDateString(locales, options)
  );

const checkFormatContainsYear = s => {
  return /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/.test(s);
};

/**
 * Formats a date into a human readable relative time string (e.g. "2 hours ago", "3 months ago")
 * @param {string | Date} date - The date to format
 * @returns {string} The formatted relative time string
 */
const formatTimeAgo = date => {
  const now = new Date();
  const past = new Date(date);
  const diffMs = now.getTime() - past.getTime();

  const seconds = Math.floor(diffMs / 1000);

  const intervals = {
    year: 31536000,
    month: 2592000,
    week: 604800,
    day: 86400,
    hour: 3600,
    minute: 60,
    second: 1
  };

  for (const [unit, secondsInUnit] of Object.entries(intervals)) {
    const interval = Math.floor(seconds / secondsInUnit);

    if (interval >= 1) {
      const plural = interval === 1 ? '' : 's';
      return `${interval} ${unit}${plural} ago`;
    }
  }

  return 'just now';
};

export {
  checkFormatContainsYear,
  formatTimeAgo,
  getDateWithTimezoneOffset,
  getDiffDatesWithFormatted,
  getMonths
};
